/**
 * Skincu mouse drag for horizontal rows.
 *
 * [data-skincu-drag]   the row can be grabbed and dragged with a mouse, the way it is
 *                      swiped on a phone. A click that ends a drag never reaches the
 *                      cards, so a video does not start playing when the row is released.
 */
(() => {
  if (window.skincuDragReady) return;
  window.skincuDragReady = true;

  const isScrollable = (row) => row.scrollWidth - row.clientWidth > 1;

  const setupDrag = (row) => {
    let startX = 0;
    let startLeft = 0;
    let dragging = false;
    let moved = false;

    row.classList.add('skincu-draggable');

    row.addEventListener('dragstart', (event) => event.preventDefault());

    row.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !isScrollable(row)) return;

      dragging = true;
      moved = false;
      startX = event.clientX;
      startLeft = row.scrollLeft;
    });

    window.addEventListener('pointermove', (event) => {
      if (!dragging) return;

      const distance = event.clientX - startX;

      if (!moved && Math.abs(distance) > 5) {
        moved = true;
        row.classList.add('is-dragging');
      }

      if (moved) {
        event.preventDefault();
        row.scrollLeft = startLeft - distance;
      }
    });

    const release = () => {
      if (!dragging) return;

      dragging = false;

      if (!moved) return;

      // Snap back on, then let the row settle on the nearest card
      const left = row.scrollLeft;

      row.classList.remove('is-dragging');
      row.scrollLeft = left;
    };

    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    row.addEventListener(
      'click',
      (event) => {
        if (!moved) return;

        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-skincu-drag]:not([data-skincu-drag-ready])').forEach((row) => {
      row.setAttribute('data-skincu-drag-ready', '');
      setupDrag(row);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
